
class Contact {

    [x: string]: any;
 	 static $inject = ['LiveChat'];
    constructor(LiveChat) {
        this.liveChat = LiveChat;
    }

    goToChat(){
        this.liveChat.contactSupport();
    }
}

export default {
    controller: Contact,
    template : require('./contact.info.html'),
    bindings: {intro: "@", clickable: "@", closure: "@"}
};
